<template>
  <div id="bottom-scroll-bar">
      <ul>
          <li v-for="(category,k) in categories" :key="k"><i :class="[k == actualCategory ? 'prendido fas ' + iconToDisplay : 'apagado fas fa-circle']"></i></li>
      </ul>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  name: 'ScrollBar',
  props: {
    view: Boolean,
    categories: {},
    position: Number,
    indice: Array
  },
  computed:{
    actualCategory(){
      if(this.position >= 0){
        if(this.position==0){
          return this.indice[0].cat  
        }
        for(let p=0; p < this.indice.length; p++){
          if(p+1 == this.indice.length){
            this.iconToDisplay = "fa-flag-checkered"
            return this.indice[this.indice.length-1].cat;
          }
          if(this.position > this.indice[p].posY && this.position < this.indice[p+1].posY){
            console.log(this.indice[p].cat)
            this.iconToDisplay = 'fa-circle'
            return this.indice[p].cat
          }
        }
      /*for(let cat in this.indice){
        console.log(this.indice)
      }*/
      
      //console.log(this.indice)
      return 'Muebles'
      }
    }
  },
  methods: {
    
  },
  data () {
    return {
      iconToDisplay: 'fa-circle'
    }
  },
  mounted () {
    console.log(this.indice)
  }
}

</script>
<style>
  div#bottom-scroll-bar {background-color: #f9bb0f;
    position: fixed;
    top: 50%;
    padding: 20px 5px;
    right: -1px;
    border-bottom-left-radius: 20px;
    border-top-left-radius: 20px;
    margin-top: -180px;
    box-shadow: -1px 1px 2px 0px #999;
    z-index:100}
  #bottom-scroll-bar p{font-family: 'Montserrat', sans-serif;font-size:0.850em;margin:0px;padding:0px;}
  #bottom-scroll-bar ul {padding: 0px;
    margin: 0px;
    list-style: none;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    flex-direction: column;}
    #bottom-scroll-bar ul li {-webkit-flex: auto;flex: auto;}
    #bottom-scroll-bar ul li span{display:none}
    #bottom-scroll-bar ul li i{font-size:0.850em}
    .prendido{color:#fff;opacity:1}
    .apagado{color:#000;opacity:.1}
    i.prendido {
    font-size: 1em!important;
    }
    i.prendido.fa-flag-checkered{
      font-size:1.500em!important;
    }
    i.apagado {
    font-size: 0.400em!important;
    }
</style>



// WEBPACK FOOTER //
// src/components/ScrollBarComponent.vue